import Header from "components/utils/Header";
import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Footer from "components/utils/Footer";

function AppLayout() {

	const { pathname } = useLocation();

	useEffect(() => {
		window.scrollTo(0, 0);
	}, [ pathname ]);

	return (
		<>
			<Header/>
			<main>
				<Outlet/>
			</main>
			<Footer/>
		</>
	);
}

export default AppLayout;